const TIPOS_PRESENTACION_ESTADO = [
  {
    id: 0,
    name: 'Pendiente'
  },
  {
    id: 1,
    name: 'Presentada'
  },
  {
    id: 2,
    name: 'En Error'
  },
  {
    id: 3,
    name: 'Revisada sin presentar'
  },
]

export {
  TIPOS_PRESENTACION_ESTADO
}
